import { defaultFill } from '../../utils/constants';
var muiLockOutline16 = {
    paths: [
        {
            path: 'M6,0 C8.209139,0 10,1.79535615 10,4 L10,6 L10.9975267,6 C11.5511774,6 12,6.4556644 12,6.99539757 L12,15.0046024 C12,15.5543453 11.544239,16 10.9975267,16 L1.00247329,16 C0.448822582,16 0,15.5443356 0,15.0046024 L0,6.99539757 C0,6.44565467 0.455760956,6 1.00247329,6 L2,6 L2,4 C2,1.85780461 3.68819532,0.108921124 5.80074392,0.00489530723 L6,0 Z M10,8 L2,8 L2,14 L10,14 L10,8 Z M6,9 C6.55228475,9 7,9.44335318 7,10.0093689 L7,11.9906311 C7,12.5082716 6.61727982,12.9349029 6.11733256,12.9932092 L6,13 C5.44771525,13 5,12.5566468 5,11.9906311 L5,10.0093689 C5,9.49172835 5.38272018,9.06509707 5.88266744,9.00679076 L6,9 Z M6,2 C4.8954305,2 4,2.8954305 4,4 L4,4 L4,6 L8,6 L8,4 C8,2.8954305 7.1045695,2 6,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Lock',
    width: 12,
    height: 16,
};
var muiLockOutline24 = {
    paths: [
        {
            path: 'M9,0 C12.3137085,0 15,2.6862915 15,6 L15,6 L15,9 L17.0066023,9 C17.5552407,9 18,9.44892021 18,10.007484 L18,10.007484 L18,22.992516 C18,23.5489341 17.5550537,24 17.0066023,24 L17.0066023,24 L0.993397683,24 C0.444759292,24 0,23.5510798 0,22.992516 L0,22.992516 L0,10.007484 C0,9.45106594 0.444946289,9 0.993397683,9 L0.993397683,9 L3,9 L3,6 C3,2.6862915 5.6862915,0 9,0 Z M16,11 L2,11 L2,22 L16,22 L16,11 Z M9,13 C9.55228475,13 10,13.4509752 10,13.990778 L10,18.009222 C10,18.5173285 9.61727982,18.9361019 9.11733256,18.9933343 L9,19 C8.44771525,19 8,18.5490248 8,18.009222 L8,13.990778 C8,13.4826715 8.38272018,13.0638981 8.88266744,13.0066657 L9,13 Z M9,2 C6.790861,2 5,3.790861 5,6 L5,6 L5,9 L13,9 L13,6 C13,3.790861 11.209139,2 9,2 Z',
            fill: defaultFill,
        },
    ],
    title: 'Lock',
    width: 18,
    height: 24,
};
var muiLockOutline = {
    base: muiLockOutline16,
    smIcon: muiLockOutline16,
    lgIcon: muiLockOutline24,
};
export { muiLockOutline };
//# sourceMappingURL=lockOutline.js.map